import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultIpProfile'
})
export class DefaultSecurityPoliciesPipe implements PipeTransform {

  transform(value: any, row: any): any {
    if (row.default) {
      return value + ' <b>(Default)<b>';
    }
    return value;
  }

}
